<template>
  <div>
    <ul class="iv-declare-list">
      <li class="iv-p-b-24 iv-p-t-24" v-for="(item, i) in list" :key="i">
        <div class="iv-pull-left">
          <p class="iv-fs-18 iv-fc-85 iv-m-t-12" style="font-weight: 800">
            <span class="iv-m-r-32">申请名称：{{item.applyName}}</span>
          </p>
          <p class="iv-fs-16 iv-fc-65 iv-m-t-12">
            <span class="iv-m-r-32">申请日期：{{timeFormat(item[map.applyDate])}}</span>
            <span v-if="item.acceptDate" class="iv-m-r-32">受理日期：{{timeFormat(item[map.acceptDate])}}</span>
            <span v-if="item.handleDate">处理完成日期：{{timeFormat(item[map.handleDate])}}</span>
          </p>
          <p class="iv-fs-16 iv-fc-65 iv-m-t-12">
            <span class="iv-m-r-32">处理状态：
              <span
                :class="{'iv-declare-green': item.certificateState == 4, 'iv-declare-yellow': item.certificateState == 3, 'iv-declare-red': item.certificateState == 5}">
                {{certificateStateName(item.certificateState)}}
              </span>
            </span>
            <span>申请名单：{{`(共${item.applyUserNum || 0}人)  `}}</span>
            <Poptip trigger="hover" :content="item.applyUserNames" placement="top-start">
              <p>
                <span class="iv-fc-45">{{computedName(item.applyUserNames)}}</span>
              </p>
            </Poptip>
          </p>
        </div>
        <div class="iv-pull-right iv-text-right">
          <span
            v-if="item.certificateState == 1"
            class="iv-declare-list-right-btn iv-pointer iv-fc-85 iv-text-center iv-m-l-16 iv-m-t-28" 
            @click="toDetailPage(item, 'update')">修改</span>
          <span
            v-if="item.certificateState == 1"
            class="iv-declare-list-right-btn iv-pointer iv-fc-85 iv-text-center iv-m-l-16 iv-m-t-28" 
            @click="toDetailPage(item, 'delete')">删除</span>
          <span
            v-if="item.certificateState == 2"
            class="iv-declare-list-right-btn iv-pointer iv-fc-85 iv-text-center iv-m-l-16 iv-m-t-28" 
            @click="toDetailPage(item, 'recall')">撤回</span>
          <span
            v-if="item.certificateState != 4 && item.certificateState != 1"
            class="iv-declare-list-right-btn iv-pointer iv-fc-85 iv-text-center iv-m-l-16 iv-m-t-28" 
            @click="toDetailPage(item, 'viewDetail')">查看详情</span>
          <span
            v-if="item.certificateState == 4"
            class="iv-declare-list-right-btn iv-pointer iv-fc-85 iv-text-center iv-m-l-16 iv-m-t-28" 
            @click="toDetailPage(item, 'viewFeedback')">查看反馈信息</span>
        </div>
      </li>
    </ul>
    <Page
      class="iv-text-center iv-m-t-40"
      v-if="showPage"
      :total="total"
      :current="current"
      :pageSize="pageSize"
      @on-change="changePage"
      @on-page-size-change="changePageSize">
    </Page>
  </div>
</template>

<script>
import { timeFormat } from '@/utils'
import Page from '@/components/page'
import IconFont from '@/components/iconfont'

export default {
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    },
    type: {
      type: String,
      default: ''
    },
    showPage: {
      type: Boolean,
      default: true
    },
    total: {
      type: Number,
      default: 1
    },
    current: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 5
    },
    map: {
      type: Object,
      default () {
        return {
          applyDate: 'applyDate',
          acceptDate: 'acceptDate',
          handleDate: 'handleDate'
        }
      }
    }
  },
  methods: {
    timeFormat,
    computedName (applyUserNames) {
      if (applyUserNames && applyUserNames.length > 8) {
        return applyUserNames.slice(0, 8) + '......'
      } else {
        return applyUserNames
      }
    },
    certificateStateName (certificateState) {
      if (certificateState == 1) {
        return '未提交'
      } else if (certificateState == 2) {
        return '未接收'
      } else if (certificateState == 3) {
        return '待反馈'
      } else if (certificateState == 4) {
        return '已反馈'
      } else if (certificateState == 5) {
        return '已驳回'
      }
    },
    changePage (page) {
      this.$emit('on-change', page)
    },
    changePageSize (page) {
      this.$emit('on-page-size-change', page)
    },
    // 查看详情
    toDetailPage () {
      this.$emit('on-detail', ...arguments)
    }
  },
  components: {
    Page,
    IconFont
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/base/variable.scss';
.iv-declare-list {
  li {
    overflow: hidden;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.15);
    .iv-declare-green {
      color: #45BC7D;
    }
    .iv-declare-yellow {
      color: #FFC757;
    }
    .iv-declare-red {
      color: #ff6557;
    }
    .iv-declare-list-right-btn {
      display: inline-block;
      width: 108px;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      border-radius: 20px;
      border: 1px solid rgba(0, 0, 0, 0.25);
      &:hover {
        color: $iv-main-hover-color !important;
        border-color: $iv-main-hover-color !important;
      }
    }
  }
}
</style>
